import React from 'react';
import './Section.css';
import './Projects.css';

const projects = [
  {
    id: 'nic-classifier',
    name: 'NIC Code Classifier',
    event: 'HackTheFuture\'25, IIT Gandhinagar',
    date: 'March 2025',
    description:
      'A semantic search tool using LLaMA embeddings to map user queries to relevant NIC codes, enabling fast, accurate, and intuitive access to government classification data.',
    tags: ['Python', 'LLaMA', 'Semantic Search', 'React', 'Flask'],
    featured: true,
    icon: '🔍',
    color: '#39d353',
  },
  {
    id: 'heartbeat',
    name: 'Heartbeat — CQS Pipeline',
    event: 'TOSS (ICICI, UltraTech)',
    date: '2023–Present',
    description:
      'NLP-driven sentiment analysis system for call recordings that integrates a Call Quality Score (CQS) framework to quantify agent performance and customer satisfaction in real time.',
    tags: ['NLP', 'Sentiment Analysis', 'LLM', 'FastAPI', 'Python'],
    featured: true,
    icon: '🎙️',
    color: '#58a6ff',
  },
  {
    id: 'evexfitness',
    name: 'EvexFitness AI Platform',
    event: 'Startup · EvexFitness AI LLP',
    date: 'Apr – Oct 2024',
    description:
      'Full-stack fitness platform with real-time AI posture correction and exercise tracking using Computer Vision (OpenCV, MediaPipe). Led a 20-member team from prototype to production.',
    tags: ['React', 'Next.js', 'GCP', 'OpenCV', 'MediaPipe', 'ML'],
    featured: true,
    icon: '💪',
    color: '#f0883e',
  },
  {
    id: 'mpce-research',
    name: 'MPCE Prediction Research',
    event: 'MoSPI, Govt. of India',
    date: 'Apr 2025–Present',
    description:
      'Ensemble ML pipeline (XGBoost, CatBoost, LightGBM) for predicting monthly per capita expenditure from HCES household data, informing national economic policy.',
    tags: ['XGBoost', 'CatBoost', 'LightGBM', 'Optuna', 'Data Science'],
    featured: false,
    icon: '📊',
    color: '#bc8cff',
  },
  {
    id: 'kaithi-ocr',
    name: 'Kaithi Language OCR',
    event: 'Thapar School of Liberal Arts',
    date: 'Jan 2026–Present',
    description:
      'Developing OCR for Kaithi — an underrepresented Indic script — using Tesseract and custom training pipelines, enhancing automated recognition for historically significant texts.',
    tags: ['Tesseract', 'OCR', 'Python', 'NLP', 'Computer Vision'],
    featured: false,
    icon: '📜',
    color: '#39d353',
  },
];

export default function Projects() {
  const featured = projects.filter(p => p.featured);
  const others = projects.filter(p => !p.featured);

  return (
    <section id="projects" className="section">
      <div className="section-inner">
        <div className="section-header">
          <span className="section-num">03.</span>
          <h2 className="section-title">projects</h2>
          <div className="section-line" />
        </div>

        <div className="projects-featured">
          {featured.map((p, i) => (
            <div key={p.id} className={`project-card featured ${i % 2 === 1 ? 'reverse' : ''}`}>
              <div className="project-mockup" style={{ '--project-color': p.color }}>
                <div className="mockup-bar">
                  <span /><span /><span />
                </div>
                <div className="mockup-body">
                  <div className="mockup-icon">{p.icon}</div>
                  <div className="mockup-name">{p.name}</div>
                  <div className="mockup-tags">
                    {p.tags.slice(0, 3).map(t => (
                      <span key={t} className="mockup-tag">{t}</span>
                    ))}
                  </div>
                </div>
              </div>
              <div className="project-info">
                <div className="project-event">{p.event} · {p.date}</div>
                <h3 className="project-name">{p.name}</h3>
                <p className="project-desc">{p.description}</p>
                <div className="project-tags">
                  {p.tags.map(t => (
                    <span key={t} className="tag">{t}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <h3 className="other-title">// other notable work</h3>
        <div className="projects-grid">
          {others.map(p => (
            <div key={p.id} className="project-mini">
              <div className="mini-top">
                <span className="mini-icon">{p.icon}</span>
                <div className="mini-meta">{p.date}</div>
              </div>
              <h4 className="mini-name">{p.name}</h4>
              <div className="mini-event">{p.event}</div>
              <p className="mini-desc">{p.description}</p>
              <div className="project-tags" style={{ marginTop: 'auto', paddingTop: '16px' }}>
                {p.tags.slice(0, 4).map(t => (
                  <span key={t} className="tag">{t}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
